<template>
  <gg-modal :is-active="isActive" v-if="isActive" @close="closeModal">
    <template #toolbar>
      Push to Live
    </template>
    <template v-if="!showMessage" #body>
      <v-row>
        <v-col cols="12">
          <div>
            Current Staging site will be pushed to your live site: <b>{{ service.softdomain }}</b>
          </div>
        </v-col>

        <v-col cols="12">
          <v-checkbox label="Overwrite Files/Folders" v-model="model.overwrite_files" :true-value="1" :false-value="0" hide-details />
          <v-checkbox label="Push Full Database" v-model="model.push_db" :true-value="1" :false-value="0" hide-details />
        </v-col>

        <template v-if="!hideDbOptions">
          <v-col cols="12">
            Choose Database Changes

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <span>Select the database structure/data changes that you would like to push to the live site</span>
            </v-tooltip>
          </v-col>

          <v-col cols="12" md="6">
            <gg-input-label class="d-block pb-1">
              Database Structure Changes
            </gg-input-label>

            <div v-if="options.structural_change_tables.length === 0" class="pt-4">
              <b>There are no changes in structure</b>
            </div>

            <v-checkbox
              v-for="(item, i) in options.structural_change_tables"
              v-model="model.structural_change_tables"
              :key="i"
              :label="item"
              :value="item"
            />
          </v-col>

          <v-col cols="12" md="6">
            <gg-input-label class="d-block pb-1">
              Database Structure in Tables
            </gg-input-label>

            <div v-if="options.datachange_tables.length === 0" class="pt-4">
              <b>There are no changes in tables</b>
            </div>

            <v-checkbox
              v-for="(item, i) in options.datachange_tables"
              v-model="model.datachange_tables"
              :key="i"
              :label="item"
              :value="item"
              hide-details
            />
          </v-col>
        </template>
      </v-row>
    </template>
    <template v-else #body>
      <v-row class="text-center">
        <v-col cols="12">
          <v-row>
            <v-col cols="12">
              <h2 class="text--black">
                Push to Live Complete!
              </h2>
            </v-col>
            <v-col cols="12">
              <v-icon color="primary" size="180">
                mdi-checkbox-marked-circle
              </v-icon>
            </v-col>
            <v-col cols="12">
              Awesome, your changes are live now
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
    <template v-if="!showMessage" #actions>
      <gg-btn secondary @click="closeModal">Cancel</gg-btn>
      <gg-btn :loading="loading" :disabled="loading" @click="goLive">Push to live</gg-btn>
    </template>
    <template v-else #actions>
      <gg-btn secondary @click="closeModal">Close</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'GoLiveModal',
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    service: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  data: () => {
    return {
      loading: false,
      showMessage: false,
      model: {
        overwrite_files: 1,
        push_db: 1,
        structural_change_tables: [],
        datachange_tables: [],
        softsubmit: 1,
        custom_push: 1,
      }
    }
  },
  computed: {
    hideDbOptions () {
      return this.model.push_db === 1
    }
  },
  methods: {
    ...mapActions({
      pushToLive: 'hosting_wp/pushToLive',
      reportError: 'reportError'
    }),
    closeModal () {
      this.showMessage = false
      this.$emit('close')
    },
    async goLive () {
      try {
        this.loading = true

        await this.pushToLive({
          insid: this.service.insid,
          _username: this.$route.params.user,
          payload: {
            ...this.model
          }
        })

        this.$emit('update')
        this.showMessage = true
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style scoped>

</style>
